export default {
  jump1: 'Jump automatically',
  LoginPassword: 'Login with password',
  quickLogin: 'Quick login',
  smsLogin: 'Login with verification code',
  usernameLogin: 'Login with password',
  loginOrRegister: 'Login / Register',
  forgetPassword: 'Forget your password?',
  login: 'Login',
  or: 'OR',
  signTips: 'No account? ',
  signTips1: 'Register',
  passwordTips: 'Forget your password?',
  backLogin: 'Back to password login',
  resetPassword: 'Reset your password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  setPassword: 'Password Reset Successful',
  loginImmediately: 'Log In',
  gender: 'Please select gender',
  nextStep: 'Next step',
  existingAccounts: 'Already have an account?',
  noAccount: 'No account?',
  immediatelyRegister: 'Register',
  backStep: 'Go back to the previous step',
  register: 'Register',
  tips1: 'The new account has been registered successfully！',
  tips2: 'Scan the QR code and follow our school’s WeChat to stay up-to-date on the most recent news.',
  tips3: 'Please scan the QR code and bind wechat to login quickly',
  tips4: 'Please scan the QR code to apply',
  tips5: 'WeChat',
  phone: 'Admission Office Tel',
  address: 'Address',
  admissionsOffice: 'Admissions Office',
  switchboard: 'Tel',
  schoolService: 'School public account',
  contactUs: 'Contact us',
  language: 'Language',
  postalCode: 'Postal Code',
  step1: 'Fill info',
  step2: 'Create account',
  step3: 'Follow WeChat',
  back: 'Back',
  sex1: 'Male',
  sex2: 'Female',
  wechatOffical: 'Wechat Official Account',
  setNew: 'The new password has been set successfully！'
}



// WEBPACK FOOTER //
// ./src/views/parentLogin/lang/en.js